export class UserCookieModel {
  // access_token: null | string;
  ccpa_opt_out: boolean | null;
  email: string;
  user_id: string;
  workspace_id: string;

  constructor(db_entry: { [key: string]: any }, user_id: string) {
    this.user_id = user_id;
    this.workspace_id = db_entry["workspace_id"];

    this.ccpa_opt_out = "ccpa_opt_out" in db_entry ? db_entry["ccpa_opt_out"] : null;
    this.email = "email" in db_entry ? db_entry["email"] : "";
    // this.access_token = "access_token" in db_entry ? db_entry["access_token"] : null;
  }

  static fromJSON(json: string): UserCookieModel {
    const db_entry = JSON.parse(json);
    return new UserCookieModel(db_entry, db_entry["user_id"]);
  }
}
